module.exports = __webpack_public_path__ + "assets/img/bg-line-driver-5efb60d0.png";